import {CollectionTemplate} from "../../collection-template";
import {Industry} from "../../industry";

export class MasterTemplate {
    _id: any;
    industries: Industry[];
    template: CollectionTemplate
    name: string;
    purpose: string;
}
